export enum PagesPathnames {
    manualPlacement = "/advert/rate",
    autoPlacement = "/source/ads"
}
